module.exports = __webpack_public_path__ + "img/icon(11).16680d62.png";